// src/Listeners/UserPresenceListener.jsx
import { useEffect } from "react";
import { supabase } from "./supabaseClient";
const UserPresenceListener = () => {
  const myHccId = localStorage.getItem("hcc_id");

  useEffect(() => {
    if (!myHccId) return;

    // Mark user as online on load
    supabase
      .from("users")
      .update({
        is_online: true,
        last_active_at: new Date().toISOString(),
      })
      .eq("hcc_id", myHccId);

    // Mark user offline when they leave
    const handleUnload = () => {
      navigator.sendBeacon(
        `${supabase.restUrl}/users?hcc_id=eq.${myHccId}`,
        JSON.stringify({
          is_online: false,
          last_active_at: new Date().toISOString(),
        })
      );
    };

    window.addEventListener("beforeunload", handleUnload);
    return () => window.removeEventListener("beforeunload", handleUnload);
  }, [myHccId]);

  return null;
};

export default UserPresenceListener;
